@if (status) {
  <div [class]="badgeColor">
    <p-icon [name]="CampaignStatus[status].toLowerCase()"></p-icon>
    <span class="tw-pl-2.5 tw-font-bold">{{ badgeLabel | translate }}</span>
  </div>
}
